const useLogout = () => {
  localStorage.clear()
  sessionStorage.clear()
  window.location.assign('/')
}

export default useLogout
